import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "effect-controls-panel-header__panel-row" }
const _hoisted_2 = { class: "effect-controls-panel-header__effect-name" }

import { useProjectStore } from '@/store/project-store'
import EffectsIcon from '@/assets/EffectsIcon.svg'
import EffectsControlPanelToggle from '@/components/effect/EffectsControlPanelToggle.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EffectControlsPanelHeader',
  setup(__props) {

const projectStore = useProjectStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "effect-controls-panel-header",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(projectStore).toggleLock(_unref(projectStore).selectedEffect.groupName)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(EffectsIcon), { class: "effect-controls-panel-header__effects-icon" }),
      _createElementVNode("div", _hoisted_2, " Customize " + _toDisplayString(_unref(projectStore).selectedEffect.name), 1)
    ]),
    _createVNode(EffectsControlPanelToggle, {
      class: "effect-controls-panel-header__toggle",
      "is-locked": _unref(projectStore).selectedEffect.isLocked
    }, null, 8, ["is-locked"])
  ]))
}
}

})